"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var Report_1 = __importDefault(require("./Report"));
exports.ModalWrapper = (0, styles_1.styled)(Modal_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '.MuiPaper-root': {
            borderRadius: 12,
            margin: 'auto',
            marginTop: theme.spacing(4),
            maxWidth: 1156,
            height: '100%',
            position: 'relative',
            maxHeight: 'calc(100% - 48px)',
            overflow: 'hidden',
        },
    });
});
var ReportModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, quoteReport = _a.quoteReport;
    return ((0, jsx_runtime_1.jsx)(exports.ModalWrapper, __assign({ open: open, onClose: onClose }, { children: (0, jsx_runtime_1.jsx)(Report_1.default, { quoteReport: quoteReport, showOnModal: true }) })));
};
exports.default = ReportModal;
